import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const selectUIState = createSelector(
  (state: RootState) => state.ui,
  data => ({
    ...data,
  }),
);

export const selectFileViewerState = createSelector(
  (state: RootState) => state.ui,
  data => data.fileViewer,
);

export const selectProcessStepByName = createSelector(
  selectUIState,
  (_uiState, uniqueName: string) => uniqueName,
  (uiState: ReturnType<typeof selectUIState>, uniqueName: string) => {
    return uiState.processStepMap[uniqueName];
  },
);
